import { render } from "./ConfirmResultTicketComponent.vue?vue&type=template&id=d1e041bc"
import script from "./ConfirmResultTicketComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmResultTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__